<template>
  <div class="zongbao">
    <div class="left">
      <div class="title">配电室列表</div>
      <ul>
        <li
          v-for="(item, index) in leftList"
          :key="index"
          :class="leftIndex == index ? 'active' : ''"
          :title="item.roomName"
          @click="roomClickHandle(index, item.id)"
        >
          <img src="../../assets/images/iconele.png" alt="" />
          <div class="sspan">{{ item.roomName }}</div>
        </li>
      </ul>
    </div>
    <div class="right">
      <div class="title" style="padding-left: 0px">环境设备配置</div>
      <div class="box">
        <div class="item">
          <operationh
            :title="'温湿度'"
            :data="rightList1"
            :showIndex="true"
            :type="8"
            @toState="changeState"
            @upItem="updateEquipmentToCabinet"
            @addItem="addEquipmentByType"
            @deleteItem="delEquipmentToCabinet"
          ></operationh>
        </div>
        <div class="item">
          <operationh
            :title="'水浸'"
            :data="rightList2"
            :showIndex="true"
            :state="state"
            :type="9"
            @toState="changeState"
            @upItem="updateEquipmentToCabinet"
            @addItem="addEquipmentByType"
            @deleteItem="delEquipmentToCabinet"
          ></operationh>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {
  Message
} from 'element-ui';
import operationh from "../shebei/setUphuanjing";
export default {
  components: { operationh },
  data() {
    return {
      id: "",
      state: false,
      leftList: [],
      leftIndex: 0,
      leftId: "",
      rightList1: [],
      rightList2: [],
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.searchRoomCabinetList();
  },
  methods: {
    changeState(val) {
      this.sate = val;
    },
    searchRoomCabinetList() {
      this.$http
        .post(
          "bma-distribution-service/equipmentCabinet/searchRoomCabinetList",
          {
            projectId: this.id,
          }
        )
        .then((res) => {
          if (res.code == 200) {
            if (res.data) {
              this.leftList = res.data;
              this.leftId = res.data[0].id;
              this.leftIndex = 0;
              this.searchEquipmentByType(8);
              this.searchEquipmentByType(9);
            } else {
              this.leftList = [];
            }
          }
        });
    },
    // 搜索设备
    searchEquipmentByType(type) {
      this.$http
        .post("bma-distribution-service/equipment/searchEquipmentByType", {
          equipmentTypeId: type,
          roomId: this.leftId,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.data) {
              if (type == 8) {
                this.rightList1 = res.data;
              }
              if (type == 9) {
                this.rightList2 = res.data;
              }
            } else {
              if (type == 8) {
                this.rightList1 = [];
              }
              if (type == 9) {
                this.rightList2 = [];
              }
            }
          }
        });
    },
    // 增加
    addEquipmentByType(type, input, equipmentCode) {
      this.$http
        .post("bma-distribution-service/equipment/addEquipmentByType", {
          equipmentTypeId: type,
          localeNumber: input,
          equipmentCode: this.id + "_" + equipmentCode,
          roomId: this.leftId,
        })
        .then((res) => {
          if (res.code == 200) {
            Message.success(res.msg);
            this.state = false;
            this.searchEquipmentByType(type);
          }
        });
    },
    // 修改配电柜名称（编号）
    updateEquipmentToCabinet(type, id, input, equipmentCode) {
      this.$http
        .post("bma-distribution-service/equipment/updateEquipmentToCabinet", {
          localeNumber: input,
          equipmentCode: equipmentCode,
          equipmentId: id,
        })
        .then((res) => {
          if (res.code == 200) {
            Message.success("修改成功");
            this.searchEquipmentByType(type);
          }
        });
    },
    // 删除
    delEquipmentToCabinet(type, id) {
      this.$http
        .post("bma-distribution-service/equipment/delEquipmentToCabinet", {
          equipmentId: id,
        })
        .then((res) => {
          if (res.code == 200) {
            Message.success("删除成功");
            this.searchEquipmentByType(type);
          }
        });
    },
    roomClickHandle(index, id) {
      this.leftIndex = index;
      this.leftId = id;
      this.state = false;
      this.searchEquipmentByType(8);
      this.searchEquipmentByType(9);
    },
  },
};
</script>

<style lang="less" scoped>
.zongbao {
  display: flex;
  .title {
    font-size: 16px;
    font-weight: 600;
    color: #152139;
    letter-spacing: 3px;
    margin-bottom: 20px;
    text-align: left;
    padding: 0 20px;
    margin-top: 20px;
  }
  .left {
    width: 337px;
    height: 849px;
    background: #f8f8f9;
    box-sizing: border-box;
    ul {
      li {
        height: 33px;
        line-height: 33px;
        font-size: 16px;
        color: #152139;
        text-indent: 15px;
        cursor: pointer;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 0 20px;
        &.active {
          font-weight: 600;
          background: rgba(16, 57, 126, 0.1);
        }
      }
      li {
        display: flex;
        align-items: center;
        img {
          width: 20px;
          margin-right: 8px;
        }
        .sspan {
          width: 220px;
          font-size: 16px;
          text-indent: 0px;
          font-weight: 600;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .right {
    width: 1278px;
    height: 836px;
    background: #f8f8f9;
    margin-left: 15px;
    padding: 20px;
    box-sizing: border-box;
    .box {
      display: flex;

      .item {
        width: 310px;
        height: 673px;
        padding: 15px;
        padding-top: 0;
        box-sizing: border-box;
        border: 1px solid #e7e7e7;
        margin-right: 20px;
        flex-shrink: 0;
      }
    }
  }
}
</style>